export const theme = {
  colors: {
    black: "#18181B",
    blackNav: "#000000",
    darkShadow: "#00000080",
    white: "#fff",
    whisper: "#F5F5FA",
    yellow: "#FCD420",
    gray: "#E4E6F0",
    grayHover: "#e8eaf2ff",
    darkGray: "#7E839A",
    blueLight: "#D6E4FF",
    blueLightHover: "#dde7fdff",
    blue: "#0044CC",
    blueHover: "#0055ffff",
    blueActive: "#3377ffff",
    lightGray: "#74788B",
    lynch: "#627489"
  },
  breakpoints: {
    mobileMax: "946px",
    mobileSmall: "500px",
    smallWindow: "1440px",
  },
};
